export class RemainingSpendOverTimeConstants {
  static readonly chartLineColor = ['#148EE6', '#3D444C', '#095B95', '#4E6D79', '#bacad0'];
}
